import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import AuthRoutes from "./routes/AuthRoutes";
import AppRoutes from "./routes/AppRoutes";
import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { NotificationsProvider } from "./contexts/NotificationContext";

const App = () => {
  return (
    <Router>
      <Routes>

        {/* Authentication Routes */}
        <Route
          path="/*"
          element={
            <AuthRoutes />
          }
        />

        {/* Protected App Routes for Admin */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <NotificationsProvider>
                <AppRoutes />
              </NotificationsProvider>
            </ProtectedRoute>
          }
        />

        {/* Protected App Routes for HOD */}
        <Route
          path="/hod/*"
          element={
            <ProtectedRoute allowedRoles={["HOD"]}>
              <NotificationsProvider>
                <AppRoutes />
              </NotificationsProvider>
            </ProtectedRoute>
          }
        />

        {/* Protected App Routes for HR */}
        <Route
          path="/hr/*"
          element={
            <ProtectedRoute allowedRoles={["HR"]}>
              <NotificationsProvider>
                <AppRoutes />
              </NotificationsProvider>
            </ProtectedRoute>
          }
        />

        {/* Protected App Routes for User */}
        <Route
          path="/user/*"
          element={
            <ProtectedRoute allowedRoles={["User"]}>
              <NotificationsProvider>
                <AppRoutes />
              </NotificationsProvider>
            </ProtectedRoute>
          }
        />

        {/* Protected App Routes for Manager */}
        <Route
          path="/manager/*"
          element={
            <ProtectedRoute allowedRoles={["Manager"]}>
              <NotificationsProvider>
                <AppRoutes />
              </NotificationsProvider>
            </ProtectedRoute>
          }
        />

      </Routes>
    </Router>
  );
};

export default App;
